import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TEmProductFileUploadsStore,
	TEmProductFileUploadsRequest,
	TEmProductFileUploadsResponsePayload,
	TEmProductFileUploadRequest,
	TEmProductFileDownloadRequest,
} from './types';

const initialState: TEmProductFileUploadsStore = {
	uploadedFiles: null,
	uploadedFilesLoading: false,
	uploadFileLoading: false,
	downloadLoading: false,
};

const emProductFileUploads = createSlice({
	name: '@@emProductFileUploads',
	initialState,
	reducers: {
		getUploadedFilesRequest: (
			state: TEmProductFileUploadsStore,
			action: PayloadAction<TEmProductFileUploadsRequest>,
		) => {
			const s = state;
			s.uploadedFilesLoading = true;
		},
		getUploadedFilesSuccess: (
			state: TEmProductFileUploadsStore,
			action: PayloadAction<TEmProductFileUploadsResponsePayload>,
		) => {
			const s = state;
			s.uploadedFiles = action.payload;
			s.uploadedFilesLoading = false;
		},
		uploadFileRequest: (
			state: TEmProductFileUploadsStore,
			action: PayloadAction<TEmProductFileUploadRequest>,
		) => {
			const s = state;
			s.uploadFileLoading = true;
		},
		uploadFileSuccess: (state: TEmProductFileUploadsStore) => {
			const s = state;
			s.uploadFileLoading = false;
		},
		downloadFileRequest: (
			state: TEmProductFileUploadsStore,
			action: PayloadAction<TEmProductFileDownloadRequest>,
		) => {
			const s = state;
			s.downloadLoading = true;
		},
		downloadFileSuccess: (state: TEmProductFileUploadsStore) => {
			const s = state;
			s.downloadLoading = false;
		},
	},
});

export default emProductFileUploads.reducer;

export const {
	getUploadedFilesRequest,
	getUploadedFilesSuccess,
	uploadFileRequest,
	uploadFileSuccess,
	downloadFileRequest,
	downloadFileSuccess,
} = emProductFileUploads.actions;
